if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";

        this.barQuantity = document.querySelector('[data-id="barQuantity"]');
        this.variantsInput = document.querySelectorAll(".product .product__info-wrapper variant-selects fieldset input");
        this.selectedVariant = [...this.variantsInput].find((input) => input.checked);
        this.productFromInput = this.form.querySelector("quantity-input input");
        this.barInput = this.barQuantity ? this.barQuantity.querySelector("input") : null;
        this.setSelectedVariantInventoryLimitOnQauntity();
      }

      setSelectedVariantInventoryLimitOnQauntity() {
        if (!this.barInput) return;
        if (!this.selectedVariant) return;
        if (!this.selectedVariant.dataset.variantInventory) return;
        if (!this.productFromInput) return;
        // let maxQuantity = parseInt(this.selectedVariant.dataset.variantInventory) > 10 ? 10 : parseInt(this.selectedVariant.dataset.variantInventory);
        let maxQuantity = parseInt(this.selectedVariant.dataset.variantInventory);
        if (this.barInput) {
          this.barInput.setAttribute("max", maxQuantity);
        }
        if (this.productFromInput) {
          this.productFromInput.setAttribute("max", maxQuantity);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";

        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        if (window.Sentry) {
          window.Sentry.addBreadcrumb({
            category: "cart",
            message: "Add to cart started",
            level: "info",
            data: { variantId: formData.get("id") },
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // console.log(`🚀 || ProductForm || .then || response:`, response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
              if (window.Sentry) {
                window.Sentry.addBreadcrumb({
                  category: "cart",
                  message: "Product added to cart",
                  level: "info",
                  data: { variantId: formData.get("id") },
                });
              }
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (window.ZiglyCapture) {
              window.ZiglyCapture(e, { feature: "add_to_cart", context: { variantId: formData.get("id") } });
            }
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
            if (this.barInput) {
              this.barInput.value = 1;
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
